import { useTranslation } from 'react-i18next'

import { Badge, type Color } from '@campai/lib-web/components/new/ui'

import { getStatusLabel, type Status } from '@/product/feedback/status'

const statusColorMap: Record<Status, Color> = {
    new: 'blue',
    planned: 'purple',
    inProgress: 'amber',
    done: 'green',
    rejected: 'neutral',
}

type StatusBadgeProps = {
    status: Status
    size?: 'default' | 'lg'
    className?: string
}

export const StatusBadge = ({ status, size, className }: StatusBadgeProps) => {
    useTranslation()

    return (
        <Badge color={statusColorMap[status]} size={size} className={className}>
            {getStatusLabel(status)}
        </Badge>
    )
}
